import reduceReducers from "reduce-reducers";

import { SUNDRY_TEMPLATE } from "constants/actionTypes";

import {
  offlineCrudReducer,
  resetStateOnRoleChangeReducer,
} from "lib/reducers";
import { deserializeSundryTemplate as deserializer } from "lib/serializers/sundryTemplates";

const sundryTemplateCrudReducer = offlineCrudReducer(SUNDRY_TEMPLATE, {
  deserializer,
});

const sundryTemplateReducer = reduceReducers(
  sundryTemplateCrudReducer,
  resetStateOnRoleChangeReducer,
);

export default sundryTemplateReducer;
